import { getCurrentInstance, VNode, h } from "vue";
import { ErrorType } from "./showErrorModal";
import { captureException } from "@/plugins/sentry";
import { BvModal, BvMsgBoxData } from "bootstrap-vue";

export const useModal = () => {
  const instance = getCurrentInstance();
  if (!instance) return {} as BvModal;
  return instance.proxy!.$root!.$bvModal;
};

export const useErrorModal = () => {
  const modal = useModal();
  const showModal = (message: string | Array<VNode>): Promise<BvMsgBoxData> => {
    // @ts-ignore
    return modal.msgBoxOk(message, {
      centered: true,
      hideHeader: true,
      okOnly: true
    });
  };
  const showErrorModal = (error: ErrorType): Promise<BvMsgBoxData> => {
    if (!error) {
      // handle undefined
      captureException(
        new Error("unknown error occurred" + JSON.stringify(error))
      );
      return showModal("エラーが発生しました。");
    } else if ("cause" in error) {
      // handle Error
      captureException(error);
      return showModal("エラーが発生しました。");
    } else if (!("response" in error) || !error.response?.data) {
      // handle response.data not existing
      captureException(error as Error);
      return showModal("エラーが発生しました。");
    }

    const errorData = error.response?.data;
    const textNodes: VNode[] = [];
    for (const key in errorData) {
      const errorObject = errorData[key];
      if (Array.isArray(errorObject)) {
        errorObject.forEach((message: string) => {
          textNodes.push(
            h(
              "p",
              {
                isRootInsert: false,
                isComment: false
              },
              [message]
            )
          );
        });
      } else {
        textNodes.push(
          h(
            "p",
            {
              isRootInsert: false,
              isComment: false
            },
            [errorObject]
          )
        );
      }
    }
    return showModal(textNodes);
  };
  return {
    showErrorModal
  };
};

export const useLoginModal = () => {
  const modal = useModal();
  const showLoginModal = (): Promise<BvMsgBoxData> => {
    return modal.msgBoxConfirm(
      "全ての機能を使うためには登録/ログインが必要です",
      {
        okTitle: "ログイン",
        cancelTitle: "キャンセル",
        cancelVariant: "gray-03",
        centered: true
      }
    );
  };
  return {
    showLoginModal
  };
};
